import React from 'react';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import classNames from 'classnames';

const StatusTable = ({ styles, timeline }) =>
  timeline ? (
    <div className={styles['status-table__wrapper']}>
      <div className={styles['status-table__table']}>
        {timeline.map(({ datetime, summary, logo }, key) => (
          <div className={styles['status-table__row']} key={key}>
            <div
              className={classNames(
                styles['status-table__cell-date'],
                styles['status-table__cell']
              )}
            >
              {dayjs(datetime).format('DD.MM.YYYY')}
            </div>
            <div
              className={classNames(
                styles['status-table__cell-summary'],
                styles['status-table__cell']
              )}
            >
              {summary}
            </div>
            <div
              className={classNames(
                styles['status-table__cell-logo'],
                styles['status-table__cell']
              )}
            >
              {logo && (
                <img
                  className={styles['status-table__cell-logo']}
                  src={logo}
                  alt="logo"
                />
              )}
            </div>
            <div
              className={classNames(
                styles['status-table__cell-mehr'],
                styles['status-table__cell']
              )}
            >
              MEHR
            </div>
          </div>
        ))}
      </div>
    </div>
  ) : null;

StatusTable.propTypes = {
  styles: PropTypes.object,
  timeline: PropTypes.array
};

export default StatusTable;
